<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-row>
    <create-list :selectedUsersIds="selectedUsersIds"
                 v-model="showCreateListDialog"
                 @clearSelectedUsers="changeSelectedUsers()"
    />
    <NewEditPromotor />

    <EditUsersInBlock :users-ids="selectedUsersIds"
                      v-model="isEditInBlockComponentShown"
                      @getUsers="getUsers()" />
    <new-user @getUsers="getUsers()" v-model="showNewUserDialog"/>
    <invite-user type="persona" v-model="showInviteUserDialog"/>
    <ImporterNew type="users" v-model="showImporterDialog"/>
    <GuestsDialog v-model="showGuestsDialog"/>
    <PeopleFiltersDialog @openPeopleFilters="toggleFiltersDialog()" v-model="showFiltersDialog" />

    <v-col cols="12" class="pl-0 py-0">
      <div class="d-flex">
        <div
          style="position: relative;
                 transition: all ease-in-out 0.3s"
          :style="{ width: areFiltersShown ? '320px' : '25px' }"
          v-if="$vuetify.breakpoint.mdAndUp">
          <SidePeopleFilters :are-filters-shown="areFiltersShown"
                             @openPeopleFilters="toggleSideFiltersVisibility()" />
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn fab
                     color="white"
                     width="30px"
                     height="30px"
                     style="position: absolute; right: -15px; top: 30px;"
                     v-on="on"
                     @click="toggleSideFiltersVisibility()">
                <v-icon color="kbBlue" size="20px">mdi-filter</v-icon>
              </v-btn>
            </template>
            <span>{{ areFiltersShown ? $t('general.hideFilters') : $t('general.seeFilters') }}</span>
          </v-tooltip>
        </div>
        <div class="pl-3"
             style="transition: all ease-in-out 0.3s"
             :style="{ width: areFiltersShown ? 'calc(100% - 320px)' : 'calc(100% - 25px)' }">
          <div class="text-h6">
            <div class="ma-0 py-0 px-3" style="text-align: center">
              <div class="d-flex flex-wrap align-end justify-space-between">
                <v-text-field
                  hide-details
                  clearable
                  color="kbDarkBlueText"
                  :placeholder="$t('general.search')"
                  v-model="search"
                >
                  <template v-slot:append>
                    <v-icon color="kbDarkBlueText">mdi-magnify</v-icon>
                  </template>
                  <template v-slot:append-outer v-if="$vuetify.breakpoint.smAndDown">
                    <v-btn fab x-small @click="toggleFiltersDialog()">
                      <v-icon color="kbBlue">mdi-filter</v-icon>
                    </v-btn>
                  </template>
                </v-text-field>
                <div class="d-flex align-center ml-4">
                  <v-btn color="kbPink"
                         class="mr-2"
                         dark
                         v-show="selectedUsersIds.length > 0"
                         @click="openEditInBlockModal()">
                    {{ $t('general.editInBlock') }}
                  </v-btn>

                  <v-btn color="kbPink"
                         class="mr-2"
                         dark
                         v-show="users.length > 0 && isSearching"
                         @click="createList()">
                    {{ $t('general.createList') }}
                  </v-btn>

                  <v-btn color="kbPink"
                         class="mr-2"
                         dark
                         v-show="selectedUsersIds && Array.isArray(selectedUsersIds) && selectedUsersIds.length"
                         @click="createList()">
                    {{ $t('general.addSelectedUsersToList') }}
                  </v-btn>

                  <PeopleTableColumnsMenu :all-columns-prop="allPeopleDirectoryHeaders"
                                          :is-menu-hidden-on-created="isPeopleTableColumnsHiddenOnCreated"
                                          :is-menu-opened-prop="isPeopleTableColumnsMenuOpened"
                                          :loading="loadingUsers"
                                          :selected-columns-prop="selectedPeopleDirectoryHeaders"
                                          @onColumnsChange="onColumnsChange"
                                          @toggleMenu="togglePeopleTableColumnsMenu" />

                  <OptionsMenu
                    @showGuestsDialog="showGuestsDialog = true"
                    @showImporter="showImporter()"
                    @showInviteUserDialog="showInviteUserDialog = true"
                    @showNewUserDialog="showNewUserDialog = true"
                  />
                  <DataTableEditor class="ml-2"/>
                </div>
              </div>
            </div>
          </div>

          <div>
            <PeopleSpreadSheet
              class="pt-3"
              :headers="selectedPeopleDirectoryHeaders"
              :itemsPerPageOptions="itemsPerPageOptions"
              :users="users"
              v-show="isTableEditingMode"
              @updateUserInline="updateUserInline($event.data, $event.userIndex)"
            />
            <PeopleList
              :itemsPerPageOptions="itemsPerPageOptions"
              :loadingUsers="loadingUsers"
              :selected-people-directory-headers="selectedPeopleDirectoryHeaders"
              :selected-users-prop="selectedUsers"
              :users="users"
              v-show="!isTableEditingMode"
              @changeSelectedUsers="changeSelectedUsers"
              @updateUserInline="updateUserInline($event.data, $event.userIndex, $event.getUsers, true)"
            />
          </div>
        </div>
      </div>
    </v-col>
  </v-row>
</template>

<script>
// Libraries
import arraysAndJsonsHelpers from '@/libs/arraysAndJsonsHelpers'
import { mapGetters, mapState } from 'vuex'
import notifications from '@/libs/notifications'
// Mixins
import UserKeybeExtraData from '@/mixins/UserKeybeExtraData'
// Components
import CreateList from '@/pages/App/People/dialogs/CreateList'
import DataTableEditor from '@/components/widgets/DataTableEditor'
import EditUsersInBlock from '@/pages/App/People/dialogs/EditUsersInBlock'
import GuestsDialog from '@/pages/App/People/dialogs/Guests.vue'
import ImporterNew from '@/components/ui/ImporterNew/ImporterNew.vue'
import InviteUser from '@/pages/App/People/dialogs/InviteUser.vue'
import NewEditPromotor from '@/pages/App/Events/dialogs/NewEditPromotor'
import NewUser from '@/pages/App/People/dialogs/NewUser.vue'
import PeopleFiltersDialog from '@/pages/App/People/dialogs/PeopleFiltersDialog'
import SidePeopleFilters from '@/pages/App/People/Filters/SidePeopleFilters'
import OptionsMenu from '@/pages/App/People/OptionsMenu'
import PeopleSpreadSheet from '@/pages/App/People/PeopleSpreadSheet'
import PeopleList from '@/pages/App/People/PeopleList'
import PeopleTableColumnsMenu from '@/pages/App/People/PeopleTableColumnsMenu'

export default {
  components: {
    CreateList,
    DataTableEditor,
    EditUsersInBlock,
    GuestsDialog,
    ImporterNew,
    InviteUser,
    NewEditPromotor,
    NewUser,
    OptionsMenu,
    PeopleFiltersDialog,
    SidePeopleFilters,
    PeopleList,
    PeopleSpreadSheet,
    PeopleTableColumnsMenu
  },
  computed: {
    ...mapGetters(['isSearching']),
    ...mapState({
      appCustomExtradatas: state => state.apps.appCustomExtradatas,
      advancedSearch: state => state.users.advancedSearch,
      importerProgress: state => state.listsPersons.importerProgress,
      isTableEditingMode: state => state.dataTables.isTableEditingMode,
      loadingFileExportUser: state => state.users.loadingFileExportUser,
      loadingUsers: state => state.users.loadingUsers,
      paginationUsers: state => state.users.paginationUsers,
      roles: state => state.roles.roles,
      selectedUser: state => state.users.selectedUser,
      users: state => state.users.users
    }),
    companyBlocked () {
      return (
        this.$store.getters.companyPaymentState === 'block' &&
        !this.$store.getters.companyIsMonthlyBilling
      )
    },
    search: {
      get () {
        return this.$store.state.users.search
      },
      set (value) {
        this.$store.commit('SET_SEARCH_USERS', value)
      }
    },
    selectedUsersIds () {
      return this.selectedUsers.map(item => item.userId) || []
    }
  },
  async created () {
    await this.setTableColumns()

    // Fixing columns not getting translated issue
    this.togglePeopleTableColumnsMenu(true)
    setTimeout(() => {
      this.togglePeopleTableColumnsMenu(false)
      this.isPeopleTableColumnsHiddenOnCreated = false
    }, 0)

    const channelsWithWhatsApp = await this.$store.dispatch('getChannelsWithWhatsApp')
    this.$store.commit('SET_CHANNELS_WITH_WHATSAPP', channelsWithWhatsApp)
  },
  data () {
    return {
      allPeopleDirectoryHeaders: [],
      areFiltersShown: false,
      authsSelectedUser: [],
      canGetUsersOnPaginationChange: false,
      dataTableKey: false,
      defaultColumns: [
        { text: '', value: 'verified', align: 'left', sortable: true },
        { text: this.$t('general.fullName'), value: 'fullName', align: 'left', sortable: true, type: 'text', required: true, translation: 'general.fullName' },
        { text: this.$t('general.firstName'), value: 'name', align: 'left', sortable: true, type: 'text', required: true, translation: 'general.firstName' },
        { text: this.$t('general.lastName'), value: 'lastName', align: 'left', sortable: true, type: 'text', required: true, translation: 'general.lastName' },
        { text: this.$t('general.email'), value: 'email', align: 'left', sortable: true, type: 'email', required: true, translation: 'general.email' },
        { text: this.$t('general.phone'), value: 'phone', align: 'left', sortable: true, type: 'phone', required: true, translation: 'general.phone' },
        { text: this.$t('general.roles'), value: 'userRoles', align: 'center', sortable: false, translation: 'general.roles' },
        { text: 'ID', value: 'UUID', align: 'center', sortable: true },
        { text: this.$t('general.method'), value: 'auths', align: 'center', sortable: true, translation: 'general.method' },
        { text: this.$t('general.creationDate'), value: 'createdAt', align: 'center', sortable: true, translation: 'general.creationDate' }
      ],
      filtersSms: {},
      isEditInBlockComponentShown: false,
      isPeopleTableColumnsHiddenOnCreated: true,
      isPeopleTableColumnsMenuOpened: false,
      itemsPerPageOptions: [50, 100, 200],
      searchExtraData: '',
      selectedPeopleDirectoryHeaders: [],
      selectedUsers: [],
      showCreateListDialog: false,
      showFiltersDialog: false,
      showGuestsDialog: false,
      showImporterDialog: false,
      showInviteUserDialog: false,
      showSendSms: false,
      showNewUserDialog: false
    }
  },
  methods: {
    changeSelectedUsers (selectedUsers = []) {
      this.selectedUsers = [...selectedUsers]
    },
    createList () {
      this.showCreateListDialog = true
    },
    getUsers () {
      this.$vuetify.goTo(0)
      this.$store.dispatch('getUsers', { headers: this.selectedPeopleDirectoryHeaders })
    },
    openEditInBlockModal () {
      this.isEditInBlockComponentShown = true
    },
    async onColumnsChange ({ allColumns = [], selectedColumns = [] }) {
      // Setting allPeopleDirectoryHeaders and selectedPeopleDirectoryHeaders
      this.allPeopleDirectoryHeaders = allColumns
      this.selectedPeopleDirectoryHeaders = selectedColumns
      // Update userKeybeAppExtraDataItems
      await this.updateUserKeybeAppExtraDataItems([
        { key: 'allPeopleDirectoryHeaders', value: allColumns },
        { key: 'selectedPeopleDirectoryHeaders', value: selectedColumns }
      ])
    },
    sendSms () {
      this.showSendSms = true
    },
    async setTableColumns () {
      try {
        await this.$store.dispatch('getAppCustomExtradatas')

        // Setting newAllPeopleDirectoryHeaders
        let newAllPeopleDirectoryHeaders = [...this.defaultColumns]

        if (this.appCustomExtradatas &&
          Array.isArray(this.appCustomExtradatas)) {
          const mappedExtraData = this.appCustomExtradatas.map((item) => ({
            text: item.name,
            value: item.name,
            align: 'left',
            sortable: item.type !== 'select' && item.type !== 'radio' && item.type !== 'checkbox',
            options: item.options || [],
            type: item.type || 'text'
          }))

          newAllPeopleDirectoryHeaders = [...newAllPeopleDirectoryHeaders, ...mappedExtraData]
        }

        // Calling the mixin function to init peopleAllAndSelectedHeaders
        const { allItems, selectedItems } = this.initUserKeybeAppExtraDataAllAndSelectedItems(
          'allPeopleDirectoryHeaders',
          'selectedPeopleDirectoryHeaders',
          this.defaultColumns,
          newAllPeopleDirectoryHeaders,
          'value'
        )
        // Setting peopleAllAndSelectedHeaders
        this.allPeopleDirectoryHeaders = allItems
        this.selectedPeopleDirectoryHeaders = selectedItems
        this.canGetUsersOnPaginationChange = true
      } catch (e) {
        console.error(e, 'Error from set table columns in People.vue')
      }
    },
    showImporter () {
      if (!this.importerProgress.finish && this.importerProgress.show) { return notifications.error('Espera mientras se crea la lista') }
      this.showImporterDialog = true
    },
    togglePeopleTableColumnsMenu (value) {
      this.isPeopleTableColumnsMenuOpened = value
    },
    toggleSideFiltersVisibility () {
      this.areFiltersShown = !this.areFiltersShown
    },
    toggleFiltersDialog () {
      this.showFiltersDialog = !this.showFiltersDialog
    },
    async updateUserInline (data, userIndex, getUsers = false, updateTableRow = false) {
      const user = arraysAndJsonsHelpers.copyJson(this.users[userIndex])
      const { UUID } = user
      let { key, secondKey, value } = data

      const keyToUpdate = key || secondKey

      if (!keyToUpdate) return notifications.error(this.$t('general.youMustAddKeyToUpdateUser'))
      if (!UUID) return notifications.error('This user doesn\'t have a UUID')

      try {
        const valuesToUpdateInUser = {}

        if (keyToUpdate === 'phone') {
          const { phone, code, number } = value
          valuesToUpdateInUser.phone = phone
          valuesToUpdateInUser.country = code
          valuesToUpdateInUser.countryCode = number
          value = { phone, phoneObj: { phone, country: code, countryCode: number } }
        } else {
          valuesToUpdateInUser[keyToUpdate] = value
        }

        if (updateTableRow) {
          this.updateTableRow(keyToUpdate, value, userIndex, user)
        }

        if (secondKey) {
          await this.updateUserExtraData({ secondKey, value, UUID })
        } else {
          await this.updateUserService(UUID, valuesToUpdateInUser)
        }

        if (getUsers) {
          this.getUsers()
        }
      } catch (e) {
        this.getUsers()
      }
    },
    updateTableRow (key, value, userIndex, user) {
      if (key === 'name' || key === 'lastName') {
        user[key] = value
        user.fullName = `${user.name} ${user.lastName}`
      } else if (key === 'phone') {
        const { phone, phoneObj } = value
        user = { ...user, phone, phoneObj }
      } else if (key === 'rolId') {
        user.userRoles = this.roles.filter(rol => value.includes(rol.id))
      } else if (typeof value === 'object' || Array.isArray(value)) {
        user[key] = JSON.stringify(value)
      } else {
        user[key] = value
      }
      this.$store.commit('SET_USER_ROW', {
        rowIndex: userIndex,
        user
      })
    },
    async updateUserExtraData ({ secondKey, value, UUID }) {
      if (!secondKey) return
      try {
        const data = {
          userId: UUID,
          extradata: [{
            field: secondKey,
            value
          }]
        }
        await this.$store.dispatch('updateUserExtradata', data)
      } catch (e) {
        console.error(e)
        this.loading = false
      }
    },
    async updateUserService (UUID, valuesToUpdateInUser) {
      await this.$store.dispatch('updateUser',
        {
          userId: UUID,
          ...valuesToUpdateInUser
        }
      )
    }
  },
  mixins: [UserKeybeExtraData],
  watch: {
    isTableEditingMode (newValue, oldValue) {
      if (oldValue && !newValue) this.getUsers()
    },
    paginationUsers: {
      handler () {
        if (this.canGetUsersOnPaginationChange) {
          this.getUsers()
        }
      },
      deep: true
    },
    selectedPeopleDirectoryHeaders () {
      this.getUsers()
    },
    search () {
      this.getUsers()
    }
  }
}
</script>
